<template>
  <div class="columns">
    <div class="column is-narrow">
      <sc-field
        label="Buscar por"
        prop="search_by">
        <sc-select
          v-model="filters.search_by"
          placeholder="Selecione"
          @input="filters.search_value = ''"
          expanded>
          <option
            v-for="searchBy in searchByList"
            :key="searchBy.value"
            :value="searchBy.value">
            {{ searchBy.label }}
          </option>
        </sc-select>
      </sc-field>
    </div>
    <div
      class="column is-narrow">
      <sc-field
        label="CEP"
        prop="search_value"
        v-if="shouldRenderCepField(filters.search_by)"
        :expanded="false">
        <sc-input
          type="search"
          ref="cepField"
          v-model="filters.search_value"
          v-mask="'cep'"
          />
      </sc-field>
      <sc-field
        label="ID"
        prop="search_value"
        v-show="filters.search_by === 'quote_id'"
        :expanded="false">
        <sc-input
          type="number"
          v-model="filters.search_value"/>
      </sc-field>
    </div>
    <div class="column is-narrow">
      <sc-field
        label="Do dia"
        v-if="filters.search_by !== 'quote_id'"
        prop="created_after">
        <sc-datepicker
          class="sc-quotations-filters__datepicker"
          v-model="filters.created_after"
          :min-date="getMinDate()"
          :max-date="getMaxDate()"/>
      </sc-field>
    </div>
  </div>
</template>
<script>
  import { Moment } from '@intelipost-js/secure-providers';
  import {
    ScButton,
    ScDatepicker,
    ScField,
    ScIcon,
    ScInput,
    ScSelect,
    ScDecimal,
  } from '@intelipost-js/secure-components';

  export default {
    name: 'sc-quotations-filters',
    props: {
      filters: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        searchByList: [
          {
            label: 'Todas',
            value: '',
          },
          {
            label: 'Cep de Origem',
            value: 'quote_origin_zip_code',
          },
          {
            label: 'Cep de Destino',
            value: 'quote_destination_zip_code',
          },
          {
            label: 'ID de Cotação',
            value: 'quote_id',
          },
        ],
      };
    },
    methods: {
      getMinDate() {
        return new Date('2021-04-11T00:00:00');
      },
      getMaxDate() {
        const { currentDate } = new Date().getTime();
        return Moment(currentDate).toDate();
      },
      shouldRenderCepField(search_by) {
        const shouldRender = search_by === 'quote_origin_zip_code' || search_by === 'quote_destination_zip_code';

        if (!shouldRender && this.$refs.cepField) {
          this.filters.search_value = null;
        }

        return shouldRender;
      },
    },
    components: {
      ScButton,
      ScDatepicker,
      ScField,
      ScIcon,
      ScInput,
      ScSelect,
      ScDecimal,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/quotations/components/sc-quotations-filters/ScQuotationsFilters.vue?2c659148